import React, { Component, Fragment } from "react";
import Button from "../../../components/atoms/Button";
import ComboBox from "../../../components/atoms/ComboBox";
import Label from "../../../components/atoms/Label";
import LabelWithInput from "../../../components/molecules/LabelWithInput";
import InformationText from "../../../components/molecules/InformationText";
import Loading from "../../../components/molecules/Loading";

import GetParameter from "../../../utils/actions/GetParameter";
import { URL_API_GET_TIPE_PINJMAN, URL_API_GET_TIPE_JAMINAN } from "../../../config/api";
import { GetListTipePinjaman } from "../../../utils/actions/GetListTipePinjaman";

export class TipePinjaman extends Component {
	_isMounted = false;

	constructor(props) {
		super(props);

		this.state = {
			loading_submit: false,
			tipe_pinjaman: {
				list: [],
				selected: 0,
				loading: false,
			},
			tipe_jaminan: {
				list: [],
				selected: 0,
				loading: false,
			},
		};
	}

	setStateList = (parent, child, value) => {
		if (this._isMounted) {
			this.setState({
				[parent]: {
					...this.state[parent],
					[child]: value,
				},
			});
		}
	};

	fetchTipeJaminan = (id, ClientID) => {
		GetParameter(URL_API_GET_TIPE_JAMINAN(id), ClientID, (hasil, errorMessage) => {
			this.setStateList("tipe_jaminan", "loading", false);

			if (!errorMessage) {
				let coleteral = hasil.product.productDetail.addons.filter((el) => {
					return el.addonCode === "CLT";
				});

				let list = [];
				coleteral[0].addonValue.split(",").forEach((data) => {
					list.push({
						text: data,
						value: data,
					});
				});

				this.setStateList("tipe_jaminan", "list", list);

				const { detail } = this.props.detailPinjaman;
				if (detail) {
					this.setStateList("tipe_jaminan", "selected", detail.collateralType);
				}
			}
		});
	};

	getListTipeJaminan = ({ name, value }) => {
		const { RefreshToken, setClientID } = this.props;

		this.setStateList("tipe_jaminan", "loading", true);
		this.setStateList(name, "selected", value);
		RefreshToken((ClientID) => {
			if (ClientID) {
				this.fetchTipeJaminan(value, ClientID);
				// setClientID && setClientID(ClientID);
			}
		});
	};

	onSubmitStep = (step) => {
		const { tipe_pinjaman, tipe_jaminan } = this.state;
		const { loanCode } = this.props.match.params;
		const { SetError, postOrPatch } = this.props;

		if (this._isMounted) {
			this.setState({
				loading_submit: true,
			});
		}

		tipe_jaminan.selected === 0 || tipe_pinjaman.selected === 0
			? SetError("Semua field di tahap ini harus diisi sebelum Anda pindah ke tahap selanjutnya.")
			: postOrPatch({
					data: { productUID: tipe_pinjaman.selected, collateralType: tipe_jaminan.selected },
					stepChange: step,
					loanCode: loanCode ? loanCode : null,
			  });
	};

	componentDidMount = () => {
		this._isMounted = true;
		//console.log("Mount Tipe Pinjaman");
		const { ClientID, ResetStatusState } = this.props;

		ResetStatusState();

		if (ClientID !== null) {
			this.setStateList("tipe_pinjaman", "loading", true);
			GetListTipePinjaman(ClientID, "active", (list) => {
				console.log(list);
				this.setStateList("tipe_pinjaman", "loading", false);
				this.setStateList("tipe_pinjaman", "list", list);
			});
		}
	};

	componentDidUpdate = (prevProps) => {
		const { ClientID, detailPinjaman } = this.props;
		const { loanCode } = this.props.match.params;

		if (detailPinjaman.detail !== prevProps.detailPinjaman.detail) {
			if (ClientID && loanCode && this.props.detailPinjaman.detail !== null) {
				const { detailPinjaman, ClientID } = this.props;

				if (detailPinjaman.detail && ClientID) {
					this.setStateList("tipe_pinjaman", "selected", detailPinjaman.detail.productUID);
					this.setStateList("tipe_jaminan", "loading", true);
					this.fetchTipeJaminan(detailPinjaman.detail.productUID, ClientID);
				}
			}
		}
	};

	componentWillUnmount = () => {
		this._isMounted = false;
	};

	render() {
		const { col, status, detailPinjaman } = this.props;
		const { tipe_jaminan, tipe_pinjaman, loading_submit } = this.state;

		return detailPinjaman.loading ? (
			<Loading />
		) : (
			<Fragment>
				<LabelWithInput label="Tipe Pinjaman" col={col} {...this.props}>
					<ComboBox name="tipe_pinjaman" isLoading={tipe_pinjaman.loading} value={tipe_pinjaman.selected} title="Tipe Pinjaman" data={tipe_pinjaman.list} onChange={(e) => this.getListTipeJaminan(e.target)} />
				</LabelWithInput>

				<LabelWithInput label="Tipe Jaminan" col={col} {...this.props}>
					<ComboBox name="tipe_jaminan" isLoading={tipe_jaminan.loading} value={tipe_jaminan.selected} title="Tipe Jaminan" data={tipe_jaminan.list} onChange={(e) => this.setStateList("tipe_jaminan", "selected", e.target.value)} />
				</LabelWithInput>

				<div className="bg-button flex-column align-items-start">
					<Button title="Selanjutnya" color="blue" width="big" loading={status.loading && loading_submit} onClick={() => this.onSubmitStep(1)} />
					<Label type="info" value="Tombol Selanjutnya akan otomatis membuat draf pinjaman baru" className="mt-2 color-text-label label-kc-s" />
				</div>

				{/* { (status.error) && <InformationText value={status.error} type='error' className='mt-3' /> } */}
			</Fragment>
		);
	}
}

export default TipePinjaman;
